import { Stack } from '@mui/material';
import Container from '@mui/material/Container';

import { useUserAccount } from '@/api/userAccount';
import { NotForAdminsAlert } from '@/components/NotForAdminsAlert';
import { PageTitle } from '@/components/PageTitle';
import { TetherInfoAlert } from '@/components/TetherInfoAlert';
import { AccountBalanceCard } from '@/components/subscriptions/AccountBalanceCard';
import { CurrentSubscriptionPeriodCard } from '@/components/subscriptions/CurrentSubscriptionPeriodCard';
import { DeviceTelemetryManagementTable } from '@/components/subscriptions/DeviceTelemetryManagementTable';
import { PaymentTroubleAlert } from '@/components/subscriptions/PaymentTroubleAlert';
import { SubscriptionStatusCard } from '@/components/subscriptions/SubscriptionStatusCard';
import { TelemetryOtaInProgressAlert } from '@/components/subscriptions/TelemetryOtaInProgressAlert';
import { UnusedLinesAlert } from '@/components/subscriptions/UnusedLinesAlert';
import { CreditsSummarySection } from '@/components/telemetryCredits/CreditsSummarySection';
import { SummaryCardRow } from '@/components/ui/SummaryCard';
import { TransactionContextProvider } from '@/context/transaction';
import { TelemetryLineChangeContextProvider } from '@/context/transaction/TelemetryLineChangeContext';
import { TETHER_URLS } from '@/hooks/useTetherDeviceIdentity';
import { showUiElementPerIridiumVar } from '@/utils';

export const TelemetryManagement = () => {
    const { data: accountData } = useUserAccount();
    const accountIridiumVar = accountData?.data?.user?.accountIridiumVar;
    const isUsingSatelliteCredits = showUiElementPerIridiumVar(accountIridiumVar, 'usesSatelliteCredits');

    return (
        <Container maxWidth="lg">
            <PageTitle title="Telemetry" />
            <NotForAdminsAlert />
            <Stack sx={{ width: 1, gap: 3 }}>
                <TetherInfoAlert
                    title="Manage Spotter Scout navigation telemetry on Tether"
                    href={TETHER_URLS.telemetry}
                    actionButtonLabel="Configure on Tether"
                >
                    Changes to telemetry frequency or data collection settings may affect your billing. Monitor your
                    usage on the Tether Dashboard.
                </TetherInfoAlert>
                <TelemetryOtaInProgressAlert />
                <PaymentTroubleAlert />
                <SummaryCardRow sx={{ width: 1 }}>
                    <SubscriptionStatusCard />
                    <AccountBalanceCard />
                    <CurrentSubscriptionPeriodCard />
                </SummaryCardRow>
                {isUsingSatelliteCredits && <CreditsSummarySection />}
                <UnusedLinesAlert />
                <TransactionContextProvider
                    type="subscription"
                    defaultBackTarget="telemetry"
                    prorationBehavior="always_invoice"
                >
                    <TelemetryLineChangeContextProvider>
                        <DeviceTelemetryManagementTable />
                    </TelemetryLineChangeContextProvider>
                </TransactionContextProvider>
            </Stack>
        </Container>
    );
};
